/**
 * Static host → CMS site mapping used by the Next.js frontend.
 *
 * Format in NEXT_PUBLIC_CMS_DOMAIN_MAP (comma-separated):
 *   jivamasaz.cz=jivamasaz,nicov.armorik.eu=nicov
 *
 * NEXT_PUBLIC_CMS_HOSTS is a simpler comma-separated list of public CMS hosts.
 * It is used for middleware / API-base decisions, NOT for host → site guessing.
 * Root domain resolution always requires an explicit entry in NEXT_PUBLIC_CMS_DOMAIN_MAP.
 */

export function getCmsDomainMap(): Record<string, string> {
  const map: Record<string, string> = {};
  const raw = process.env.NEXT_PUBLIC_CMS_DOMAIN_MAP || '';
  if (!raw) return map;
  for (const entry of raw.split(',')) {
    const [host, slug] = entry.trim().split('=');
    if (host && slug) {
      map[host.trim().toLowerCase()] = slug.trim();
    }
  }
  return map;
}

export function getCmsHosts(): string[] {
  const raw = process.env.NEXT_PUBLIC_CMS_HOSTS || '';
  return raw
    .split(',')
    .map((h) => h.trim().toLowerCase())
    .filter(Boolean);
}

export function resolveCmsSiteSlug(host: string): string | null {
  const normalized = host.toLowerCase().split(':')[0];
  const map = getCmsDomainMap();
  return map[normalized] || null;
}
